// WCAG 2.1 relative-luminance + contrast ratio for #rrggbb pairs. Lifted
// out of AiGeneratedBadge's contrast test (AI-253 — see
// src/components/AiGeneratedBadge/index.contrast.test.tsx) so the send-glyph
// contrast guard (WCAG 1.4.11, ChatInput) can share the same math instead of
// duplicating it.

// Matches a strict 6-digit #rrggbb hex color only. `primary_color` off the
// merchant record is an unvalidated bare string — a named color (`red`) or an
// `rgb()`/`rgba()` value would parseInt() to NaN in `luminance`, so callers
// must check this before calling `contrastRatio` and fall back otherwise.
const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/

export function isHexColor(value: string): boolean {
  return HEX_COLOR_RE.test(value)
}

function luminance(hex: string): number {
  const c = hex.replace('#', '')
  const channels = [0, 2, 4].map(i => parseInt(c.substr(i, 2), 16) / 255)
  const linear = channels.map(v =>
    v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4
  )
  return 0.2126 * linear[0] + 0.7152 * linear[1] + 0.0722 * linear[2]
}

export function contrastRatio(fg: string, bg: string): number {
  const l1 = luminance(fg)
  const l2 = luminance(bg)
  const [hi, lo] = l1 > l2 ? [l1, l2] : [l2, l1]
  return (hi + 0.05) / (lo + 0.05)
}
